import { ga } from 'js/analytics/adapters'
const funnelSteps = {
  'signUp.stats': 'metrics',
  'signUp.pickAccountMethod': 'account-info',
  'subscription.choosePlan': 'choose-plan',
  'subscription.pay': 'payment',
}
export const trackSignUpFunnelStep = (step) => {
  ga.virtualPageView(`/signup/${funnelSteps[step]}`)
}
